import type { PropsWithChildren } from 'react';
import { Ui } from '@silvertours/front-shared';
import { useTheme } from '@emotion/react';
import { List, MenuButton, StyledMenuIcon } from './HiddenLinksPopover.styles';

const HiddenLinksPopover = ({
  children,
  label,
}: PropsWithChildren<{ label: string }>) => {
  const { spacing } = useTheme();
  return (
    <Ui.Popover
      button={{
        as: MenuButton,
        icon: <StyledMenuIcon />,
        'aria-label': label,
      }}
    >
      <Ui.PopoverPanel>
        <Ui.PanelContentWrapper padding={spacing[50]} width="255px">
          <List>{children}</List>
        </Ui.PanelContentWrapper>
      </Ui.PopoverPanel>
    </Ui.Popover>
  );
};

export { HiddenLinksPopover };
